import React, { useState } from 'react';
import DefaultModal from 'components/Modal/DefaultModal';
import { Row, Col, Form, FormGroup, Label, Input } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import ListBroadcastListModal from '../ListBroadcastListModal';

const ExportContactsModal = ({ isModalOpen, onModalToggle, contacts }) => {
  const [campaignType, setCampaignType] = useState('whatsapp');
  const [listBroadcastListModalOpen, setListBroadcastListModalOpen] =
    useState(false);

  const handleSelectCampaigns = () => {
    setListBroadcastListModalOpen(true);
  };

  return (
    <>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={onModalToggle}
        title="Exportar Contatos"
        showCloseButton={false}
      >
        <h1 className="mb-0 pb-0">Tipos de campanha</h1>
        <h2 style={{ fontSize: '0.8rem', marginBottom: '0.6rem' }}>
          Selecione algum dos tipos de campanha abaixo
        </h2>
        <Form>
          <Row>
            <Col sm="12">
              <FormGroup tag="fieldset">
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="campaignType"
                      value="whatsapp"
                      checked={campaignType === 'whatsapp'}
                      onChange={() => setCampaignType('whatsapp')}
                    />
                    WhatsApp
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="campaignType"
                      value="sms"
                      checked={campaignType === 'sms'}
                      onChange={() => setCampaignType('sms')}
                    />
                    SMS
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="campaignType"
                      value="discador"
                      checked={campaignType === 'discador'}
                      onChange={() => setCampaignType('discador')}
                    />
                    Discador
                  </Label>
                </FormGroup>
              </FormGroup>
            </Col>
            <Col sm="12">
              <ReactButton
                btnColor="confirmation"
                type="button"
                size="md"
                onClick={handleSelectCampaigns}
              >
                Selecionar
              </ReactButton>
            </Col>
          </Row>
        </Form>
      </DefaultModal>

      <ListBroadcastListModal
        show={listBroadcastListModalOpen}
        onModalToggle={setListBroadcastListModalOpen}
        contacts={contacts}
        campaignType={campaignType}
      />
    </>
  );
};

export default ExportContactsModal;
